export {
  FullWidthImage,
  type FullWidthImageProps,
  type FullWidthImageAspectProps,
  type FullWidthImageDimsProps,
} from "./FullWidthImage";
